/**
 * Created by pajicv on 10/26/18.
 */
import React from 'react';
import { Button, Typography, withStyles } from '@material-ui/core';
import WorkerSubTaskDetail from '../Tasks/WorkerSubTaskDetail';
import classnames from 'classnames';
import {MAIN_COLOR} from '../../firebase-config';
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
    fab: {
        position: 'absolute',
        top: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
    fabText: {
        color: MAIN_COLOR,
        fontSize: 22
    }
});

class TaskOverlayWorker extends React.Component {

    render() {
        const { classes, onCloseTask } = this.props;
        return (
            <div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'auto' }}>
                <React.Fragment>
                    <Button className={classes.fab} onClick={onCloseTask}>
                        <CloseIcon />
                    </Button>
                    <WorkerSubTaskDetail {...this.props} />
                </React.Fragment>
            </div>
        );
    }
}

export default withStyles(styles)(TaskOverlayWorker);



// WEBPACK FOOTER //
// ./src/components/Overlay/TaskOverlayWorker.js